import { CommonModule } from '@angular/common';
import { AfterViewInit, OnInit, Component, ElementRef, Input, ViewChild, OnChanges } from '@angular/core';
import { highlightElement } from 'prismjs';
import 'prismjs/components/prism-sql'; // necessary for syntax highlighting to work
import 'prismjs/components/prism-python'; // necessary for syntax highlighting to work

/* eslint-disable @angular-eslint/component-selector */
@Component({
  standalone: true,
  selector: 'mode-code-highlight',
  imports: [CommonModule],
  templateUrl: './code-highlight.component.html',
  styleUrls: ['./code-highlight.component.scss'],
})
export class CodeHighlightComponent implements OnInit, AfterViewInit, OnChanges {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() lang: string;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() lineNumbers: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() start: number;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() query: string;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @ViewChild('code') content: ElementRef;
  public prismLoaded = false;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  public languageClass: string;
  public code: any;
  private HIGHLIGHT_LIMIT = 35000; //need to move this const out of legacy to avoid circ dependency

  constructor() {}

  ngOnInit() {
    this.languageClass = `language-${this.lang}`;
  }
  ngAfterViewInit() {
    this.code = this.content.nativeElement;
    if (this.code.innerText && this.code.innerText.length < this.HIGHLIGHT_LIMIT) {
      highlightElement(this.code, false);
      this.prismLoaded = true;
    }
  }
  /*
  Onchanges has to be added because when the afterViewInit is fired
  the ui never updates.  SetTimeout is used to detect the view child.
  If ngAfterViewInit is replaced with ngOnChanges then the same issue
  of the ui not updating returns
  */
  ngOnChanges(changes: any): void {
    if (changes?.query) {
      setTimeout(() => {
        if (this.content?.nativeElement && this.code.innerText && this.code.innerText.length < this.HIGHLIGHT_LIMIT) {
          /*
          Updates the ui text by passing the query from the
          dataview
          */
          this.content.nativeElement.textContent = this.query;
          highlightElement(this.content.nativeElement);
        }
      }, 0);
    }
  }
}
